import React, { useEffect, useRef, useState } from 'react';
import SkuCard from './card/skucard';
import {
  Button,
  Grid,
  Modal,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";

import axios from '../../../../../../../api/axios';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

function Sku() {
  const [searchTerm, setSearchTerm] = useState("");
  const [skus, setSKUs] = useState([]);
  const [categories, setCategories] = useState([]);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [openModal, setOpenModal] = useState(false);
  const [skuName, setSkuName] = useState(""); // SKU Name
  const [categoryId, setCategoryId] = useState(""); // Selected Category
  const [currentSKU, setCurrentSKU] = useState(null);
  const errRef = useRef();
  const [errMsg, setErrMsg] = useState("");


  // Fetch categories
  const business_entity_id = sessionStorage.getItem("configBizEntityId");

  useEffect(() => {
    fetchSKUs();
    fetchCategories();
  }, [business_entity_id]);

  const fetchSKUs = async () => {
    try {
      const response = await axios.get(
        `retail/sku/${business_entity_id}`
      );
      const transformedData = response.data.map(sku => ({
        id: sku.id,
        skuCode: sku.sku_code,
        categoryId: sku.category_id,
        description: sku.description,
        retailShopId: sku.retail_shop_id
      }));
      setSKUs(transformedData || []);
    } catch (error) {
      console.error("Error fetching SKUs:", error);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await axios.get(
        `retail/categories/${business_entity_id}`
      );
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const handleOpenModal = (sku = null) => {
    setCurrentSKU(sku);
    if (sku) {
      setSkuName(sku.skuCode);
      setCategoryId(sku.categoryId);
    } else {
      setSkuName("");
      setCategoryId("");
    }
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setErrMsg("");
  };

  const handleSaveSKU = async () => {
    if (!skuName.trim()) {
      setErrMsg("SKU name is required.");
      setTimeout(() => setErrMsg(""), 3000);
      return;
    }
    if (!categoryId) {
      setErrMsg("Please select a category.");
      setTimeout(() => setErrMsg(""), 3000);
      return;
    }

    try {
      const payload = {
        skuCode: skuName,
        categoryId,
        description: "",
        businessEntityId: business_entity_id,
      };

      const url = currentSKU ? `retail/sku/${currentSKU.id}` : "retail/sku";
      const methods = currentSKU ? axios.put : axios.post;

      const response = await methods(
        url,
        payload
      );

      if (response.status === 200 || response.status === 201) {
        fetchSKUs();
        setOpenModal(false);
        setSnackbarMessage(
          currentSKU ? "SKU updated successfully" : "SKU added successfully"
        );
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error("Error:", error);
      setErrMsg("Error: operation failed");
      setTimeout(() => setErrMsg(""), 3000);
    }
  };

  const handleDeleteSKU = async (id, deleteOption) => {

    try {
      console.log("aaaaaa", deleteOption)
      const url = (deleteOption === "unlink") ? `retail/sku/${id}?unlink=true` : `retail/sku/${id}`;
      const response = await axios.delete(
        url
      );

      if (response.status === 200) {
        fetchSKUs();
        setSnackbarMessage("SKU deleted successfully");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error("Error deleting SKU:", error);
      setSnackbarMessage("Failed to delete SKU");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };

  const filteredSKUs = (skus || []).filter((sku) =>
    (sku.skuCode || "").toLowerCase().includes(searchTerm?.toLowerCase() || "")
  );


  return (
    <div className="wrap">
      <div className="roww">
        <div className="search">
          <input
            type="text"
            className="searchTerm"
            placeholder="Search SKUs"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <Button
            variant="contained"
            onClick={() => handleOpenModal(null)}
            style={{ backgroundColor: "#4CAF50", color: "white" }}
          >
            Add SKU
          </Button>
        </div>
      </div>

      {searchTerm !== "" && filteredSKUs.length === 0 && skus.length !== 0 && (
        <div className="no-match-found">
          <span className="message">No match found for your SKU search!</span>
        </div>
      )}
      {skus.length === 0 && (
        <div className="no-match-found">
          <span className="message">No SKUs have been added</span>
        </div>
      )}

      <Grid container spacing={3}>
        {filteredSKUs.map((sku) => (
          <Grid item key={sku.id} xs={12} sm={6} md={4} lg={3}>
            <SkuCard
              section={sku.skuCode}
              onEdit={() => handleOpenModal(sku)}
              onDelete={(deleteOption) => handleDeleteSKU(sku.id, deleteOption)}
            />
          </Grid>
        ))}
      </Grid>

      <Modal open={openModal} onClose={handleCloseModal}>
        <div className="modal-container">
          <h6>{currentSKU ? "Update SKU" : "Add New SKU"}</h6>
          <p ref={errRef} className={errMsg ? "errmsg-login" : "offscreen"}>
            {errMsg}
          </p>

          <label htmlFor="sku-name">SKU Name:</label>
          <TextField
            id="sku-name"
            value={skuName}
            onChange={(e) => setSkuName(e.target.value)}
            fullWidth
          />

          <label htmlFor="category">Category:</label>
          <Select
            id="category"
            value={categoryId}
            onChange={(e) => setCategoryId(e.target.value)}
            fullWidth
          >
            {categories.map((category) => (
              <MenuItem key={category.id} value={category.id}>
                {category.name}
              </MenuItem>
            ))}
          </Select>

          <div style={{ marginTop: "16px", display: "flex", justifyContent: "space-between" }}>
            <Button variant="contained" onClick={handleSaveSKU}>
              {currentSKU ? "Update" : "Save"}
            </Button>
            <Button variant="outlined" onClick={handleCloseModal}>
              Cancel
            </Button>
          </div>
        </div>
      </Modal>

      <Snackbar open={openSnackbar} autoHideDuration={6000}>
        <MuiAlert severity={snackbarSeverity}>{snackbarMessage}</MuiAlert>
      </Snackbar>
    </div>
  );
}

export default Sku;
